module.exports = __webpack_public_path__ + "img/youtube.fb35028c.svg";